/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { tenantsDelete } from "../../funcs/tenantsDelete.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  tenantId: z.string(),
};

export const tool$tenantsDelete: ToolDefinition<typeof args> = {
  name: "tenants-delete",
  description: `Delete Tenant

Deletes the tenant and all associated destinations.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await tenantsDelete(
      client,
      args.tenantId,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
